
<script>
  import { Route, router } from 'tinro'
  import { onMount } from 'svelte'
  import Index from './pages/index.svelte'
  import Home from './pages/home.svelte'
  import Notification from './components/notification.svelte'
  import UpsertBot from './pages/upsertbot.svelte'
  import Chat from './pages/chat.svelte'
  import DataSet from './pages/dataset.svelte'
  import Profile from './pages/profile.svelte'
  import Favorite from './pages/favorite.svelte'
  import { isLoggedIn, screenWidth, bodyWidth, Context, isDesktop } from './context.js'
  
  //router.mode.history()
  function onResize() {
    let winWidth = window.innerWidth
    screenWidth.set(winWidth)
    isDesktop.set((winWidth >= 768))
    if (winWidth > 1600) {
      bodyWidth.set('82%')
    } else if (winWidth > 1440) {
      bodyWidth.set('86%')
    } else if (winWidth > 1280) {
      bodyWidth.set('92%')
    } else {
      bodyWidth.set('94%')
    } 
  }
  
  onMount(async () => {
    Context.preInit()
    Context.init()
    onResize();
    window.addEventListener('resize', onResize);
  })

</script>

<Notification/>

<Route>
  
  <Route path='/'><Index/></Route>
  {#if $isLoggedIn}
  <Route path='/home'><Home/></Route>
  <Route path='/createbot'><UpsertBot/></Route>
  <Route path='/editbot/:id'><UpsertBot/></Route>
  <Route path='/chat'><Chat/></Route>
  <Route path='/bot/:botId/dataset'><DataSet/></Route>
  <Route path='/profile'><Profile/></Route>
  <Route path='/favorite'><Favorite/></Route>
  {/if}
  <Route fallback redirect='/'>404 Not Found!!</Route>
</Route>
